import { Outlet } from "react-router";

import GoToHome from "@/auth/components/GoToHome";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";

export default function RequireReflagAdmin() {
  const { user } = useEnvironment();

  if (!user?.isReflagAdmin) {
    return <GoToHome />;
  }

  return <Outlet />;
}
